import { AuthenticatedTemplate } from '@azure/msal-react';
import brzTheme from '@brz/brz-global-mui-theme';
import {
  AppBar,
  BreadcrumbProvider,
  DynamicBreadcrumbs,
  NavigationMenu,
  NavigationMenuFooter,
} from '@common-components';
import Drawer from '@mui/material/Drawer';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import { AppInitializationProvider, NotificationProvider } from '@providers';
import {
  ClientSideRowModelModule,
  LocaleModule,
  ModuleRegistry,
  QuickFilterModule,
  RowApiModule,
  RowSelectionModule,
  ValidationModule,
} from 'ag-grid-community';
import { ColumnMenuModule, LicenseManager } from 'ag-grid-enterprise';
import { Settings } from 'luxon';
import { useState } from 'react';
import { BrowserRouter } from 'react-router';
import styles from './App.module.css';
import { LocalizationProvider } from './localization/LocalizationProvider';
import { AppRoutes } from './routing';

if (import.meta.env.VITE_AG_GRID_LICENSE_KEY) {
  LicenseManager.setLicenseKey(import.meta.env.VITE_AG_GRID_LICENSE_KEY);
}
ModuleRegistry.registerModules([
  RowSelectionModule,
  ClientSideRowModelModule,
  ValidationModule,
  QuickFilterModule,
  ColumnMenuModule,
  LocaleModule,
  RowApiModule,
]);
Settings.defaultZone = 'Europe/Berlin';
Settings.defaultLocale = 'de-DE';
Settings.defaultOutputCalendar = 'gregory';

function App() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <BrowserRouter>
      <LocalizationProvider>
        <ThemeProvider theme={brzTheme}>
          <AppInitializationProvider>
            <AuthenticatedTemplate>
              <NotificationProvider>
                <BreadcrumbProvider>
                  <AppBar onMenuClick={() => setDrawerOpen(!drawerOpen)} />
                  <DynamicBreadcrumbs />
                  <div className={styles.mainContentContainer}>
                    <AppRoutes />
                  </div>

                  <Drawer
                    variant="temporary"
                    open={drawerOpen}
                    onClose={() => setDrawerOpen(false)}
                  >
                    <NavigationMenu onItemClick={() => setDrawerOpen(false)} />
                    <NavigationMenuFooter />
                  </Drawer>
                </BreadcrumbProvider>
              </NotificationProvider>
            </AuthenticatedTemplate>
          </AppInitializationProvider>
        </ThemeProvider>
      </LocalizationProvider>
    </BrowserRouter>
  );
}

export default App;
